import React from 'react'

interface ChartFilledIconProps {
  color?: string
  height?: number
  size?: number
  styles?: object
  viewBox?: string
  width?: number
}

export const ChartFilledIcon: React.FC<ChartFilledIconProps> = ({
  color = 'currentColor',
  height,
  size = 16,
  styles,
  viewBox = '0 0 16 16',
  width,
}) => {
  return (
    <svg
      aria-hidden={true}
      className="kyper-icon"
      focusable={false}
      height={height || size}
      style={styles}
      viewBox={viewBox}
      width={width || size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 1.5C16 0.671573 15.3284 0 14.5 0H1.5C0.671573 0 0 0.671573 0 1.5V14.5C0 15.3284 0.671573 16 1.5 16H14.5C15.3284 16 16 15.3284 16 14.5V1.5ZM12.8 5.1C13.0209 5.26568 13.0657 5.57909 12.9 5.8L9.90003 9.8C9.71746 10.0434 9.36163 10.0687 9.14648 9.85355L6.55413 7.2612L3.90003 10.8C3.73434 11.0209 3.42094 11.0657 3.20003 10.9C2.97912 10.7343 2.93434 10.4209 3.10003 10.2L6.10003 6.2C6.28259 5.95658 6.63843 5.93129 6.85358 6.14645L9.44593 8.7388L12.1 5.2C12.2657 4.97908 12.5791 4.93431 12.8 5.1Z"
        fill={color}
      />
    </svg>
  )
}
